import API from '../dataApi';

// -- Family --------------------------------------------------------------------
export const createFamily = (data) => API.post('/family', data);
export const getMyFamily = (derasarId) => API.get('/family/mine', { params: { derasarId } });
export const getFamilies = (derasarId) => API.get('/family', { params: { derasarId } });
export const getFamily = (id) => API.get(`/family/${id}`);
export const joinFamily = (id) => API.post(`/family/${id}/join`);
export const joinFamilyByEmail = (headEmail, derasarId) => API.post('/family/join-by-email', { headEmail, derasarId });
export const approveFamilyMember = (familyId, userId, action) =>
  API.put(`/family/${familyId}/approve/${userId}`, { action });
export const removeFamilyMember = (familyId, userId) =>
  API.delete(`/family/${familyId}/member/${userId}`);
export const leaveFamily = (familyId) => API.delete(`/family/${familyId}/leave`);
export const inviteFamilyMember = (familyId, email) => API.post(`/family/${familyId}/invite`, { email });
export const respondToFamilyInvite = (familyId, action) => API.put(`/family/${familyId}/invite/respond`, { action });
